export default __webpack_public_path__ + "static/media/twitter.192f378b.svg";